export default class StickyReserveNav{
	constructor(){
		const stickyReserveNav = document.querySelector(".stickyReserveNav");
		setTimeout(()=>{
			if(stickyReserveNav) this.initialize(stickyReserveNav)	
		}, 100);
	}
	initialize(stickyReserveNav){
		const footer = document.querySelector(".wedding-top_photoservice") || document.querySelector(".footer");
		const isWedding = document.body.classList.contains("wedding");
		if(window.currentContext == "pc"){
			ScrollTrigger.create({
				trigger: stickyReserveNav,
				start: ()=>"bottom bottom-="+rpx(30),
				endTrigger: footer,
				end: ()=>"bottom bottom",
				pin: true,
				pinSpacing: false
			});
			ScrollTrigger.create({
				trigger: footer,
				start: ()=>"top bottom",
				onEnter: ()=>{ stickyReserveNav.classList.add("stuck"); },
				onLeaveBack: ()=>{ stickyReserveNav.classList.remove("stuck"); }
			});
		}else{
			ScrollTrigger.create({
				trigger: stickyReserveNav,
				start: ()=>"top top",
				endTrigger: footer,
				end: ()=>"top bottom",
				onLeave: ()=>{ stickyReserveNav.classList.add("stuck"); },
				onEnterBack: ()=>{ stickyReserveNav.classList.remove("stuck"); }
			});
		}
	}
}